import { render } from "./PhoneGroup.vue?vue&type=template&id=ab3c012a&scoped=true"
import script from "./PhoneGroup.vue?vue&type=script&lang=js"
export * from "./PhoneGroup.vue?vue&type=script&lang=js"

import "./PhoneGroup.vue?vue&type=style&index=0&id=ab3c012a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab3c012a"]])

export default __exports__